export const reducerCases = {
    SET_TOKEN: "SET_TOKEN",
    SET_USER: "SET_USER",
    SET_PLAYLISTS: "SET_PLAYLISTS",
    SET_PLAYING: "SET_PLAYING",
    SET_PLAYER_STATE: "SET_PLAYER_STATE",
    SET_PLAYLIST: "SET_PLAYLIST",
    SET_PLAYLIST_ID: "SET_PLAYLIST_ID",
  };